import { CSSProperties } from 'react';
import { ISliderIndents } from '../../types';

interface IGetSlideStyleParams {
  indents: ISliderIndents;
  isLastSlide: boolean;
}

export function getSlideStyle(params: IGetSlideStyleParams): CSSProperties {
  const { indents, isLastSlide } = params;
  const { right = 0, between = 0 } = indents;

  if (isLastSlide) {
    return {
      // маржин схлопывается
      paddingRight: `${right}px`,
    };
  }

  return {
    marginRight: `${between}px`,
  };
}
